import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-grid gap-2" }
const _hoisted_5 = { class: "my-2" }
const _hoisted_6 = { class: "small" }
const _hoisted_7 = {
  style: {"font-size":"12px"},
  class: "w-100 d-flex justify-space-between m-1"
}
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex search-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultipleOperationOfficeAutoComplete = _resolveComponent("MultipleOperationOfficeAutoComplete")!
  const _component_MultipleDeviceTypeAutoComplete = _resolveComponent("MultipleDeviceTypeAutoComplete")!
  const _component_DeviceIdAutoComplete = _resolveComponent("DeviceIdAutoComplete")!
  const _component_VehicleAutoComplete = _resolveComponent("VehicleAutoComplete")!
  const _component_FirmwareVersionAutoComplete = _resolveComponent("FirmwareVersionAutoComplete")!
  const _component_RangeDatePicker = _resolveComponent("RangeDatePicker")!
  const _component_ValidationErrors = _resolveComponent("ValidationErrors")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.searchAreaClass)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      (!_ctx.formHidden)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.i18n.global.t('pages.common.filter.title')), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [
        (_ctx.formHidden)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!_ctx.formHidden)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["strpied-tabled-with-hover", { 'd-none': _ctx.formHidden }])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_MultipleOperationOfficeAutoComplete, {
          modelValue: _ctx.operation_office_company,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.operation_office_company) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_MultipleDeviceTypeAutoComplete, {
          modelValue: _ctx.selectedDeviceTypes,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDeviceTypes) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_DeviceIdAutoComplete, {
          modelValue: _ctx.device,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.device) = $event)),
          operationOffices: _ctx.operation_office_company
        }, null, 8, ["modelValue", "operationOffices"]),
        _createVNode(_component_VehicleAutoComplete, {
          modelValue: _ctx.vehicle,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vehicle) = $event)),
          operationOffices: _ctx.operation_office_company,
          requestParams: { type: 'filter' }
        }, null, 8, ["modelValue", "operationOffices"]),
        _createVNode(_component_FirmwareVersionAutoComplete, {
          modelValue: _ctx.firmware,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firmware) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ValidationErrors, {
          messages: _ctx.errors['activationDateRangeEnd'] ?? []
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.i18n.global.t('pages.deviceFirmware.applyDate')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RangeDatePicker, {
                  modelValue: _ctx.form.activationDateRange,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.activationDateRange) = $event)),
                  maxRange: _ctx.deviceFirmwareDefaultDaysRange,
                  format: 'yyyy/MM/dd',
                  isError: _ctx.errors?.activationDateRangeEnd?.length > 0
                }, null, 8, ["modelValue", "maxRange", "isError"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["messages"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: _ctx.handleClickSearch,
            style: _normalizeStyle({
              backgroundColor: _ctx.isDeviceListLoading ? '#B3B8BB' : '',
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.filterBtnText), 1)
            ]),
            _: 1
          }, 8, ["onClick", "style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            onClick: _ctx.clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.i18n.global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ], 2)
  ], 2))
}